<template>
  <fieldset class="custom-fieldset">
    <legend>Pojazd nr {{ partIndex + 1 }}</legend>
    <v-row>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Wypożyczalnia*" v-model="contextPart.name" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Termin odbioru*"
          v-model="contextPart.start_date"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Termin zwrotu*" v-model="contextPart.end_date" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Typ pojazdu*" v-model="contextPart.car_class" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Miejsce odbioru*" v-model="contextPart.from" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Miejsce zwrotu*" v-model="contextPart.to" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Cena za dzień*"
          v-model="contextPart.price_per_day"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" cols="12">
        <v-textarea label="Komentarz" v-model="contextPart.comment" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
    </v-row>
  </fieldset>
</template>

<script>
export default {
  name: "CarForm",
  props: {
    part: {
      required: true
    },
    partIndex: {
      required: true,
      type: Number
    }
  },
  computed: {
    contextPart: {
      get() {
        return this.part;
      },
      set(val) {
        this.$emit("update:part", val);
      }
    }
  },
  methods: {
    isRequired(v) {
      return (v != null && v.length > 0) || "Pole wymagane";
    }
  }
};
</script>

<style scoped></style>
